import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import FlexContainer from 'core-system/FlexContainer'
import Checkbox from 'core-system/Checkbox'
import WorksiteGroupDropdown from 'features/Programs/Launch/Components/WorksiteGroupDropdown'
import { SegmentListType } from 'features/Programs/Shared/types'

const Block = styled.div`
  &:not(:first-child) {
    margin-top: 1rem;
  }
`

const Label = styled(Text)`
  margin-bottom: 0.35rem;
  display: block;
`

const DropdownWrap = styled.div`
  width: 100%;
  max-width: 100%;
`

const OptionsRow = styled(FlexContainer)`
  flex-wrap: wrap;
  gap: 1.25rem;
  align-items: center;
  margin-top: 1rem;
`

export interface EnrollmentTargetBlockProps {
  /** Custom groups only; same shape as program launch picker. */
  groupItems: SegmentListType[]
  activeGroupItems: SegmentListType[]
  onActiveGroupItemsChange: (items: SegmentListType[]) => void
  /** Employer tags; same picker shape as groups. */
  tagItems: SegmentListType[]
  activeTagItems: SegmentListType[]
  onActiveTagItemsChange: (items: SegmentListType[]) => void
  removeNonMatchingMembers: boolean
  onRemoveNonMatchingChange: (next: boolean) => void
  isActive: boolean
  onActiveChange: (next: boolean) => void
  showGroupControls: boolean
}

const EnrollmentTargetBlock: React.FC<EnrollmentTargetBlockProps> = ({
  groupItems,
  activeGroupItems,
  onActiveGroupItemsChange,
  tagItems,
  activeTagItems,
  onActiveTagItemsChange,
  removeNonMatchingMembers,
  onRemoveNonMatchingChange,
  isActive,
  onActiveChange,
  showGroupControls,
}) => {
  const groupsDisabled = groupItems.length === 0
  const tagsDisabled = tagItems.length === 0

  return (
    <>
      <Block>
        <Label variant='body2' color='grey600' fontWeight={600}>
          Target groups
        </Label>
        <DropdownWrap>
          <WorksiteGroupDropdown
            items={groupItems}
            activeItems={activeGroupItems}
            onItemCallback={onActiveGroupItemsChange}
            width='100%'
            minWidth='100%'
            disabled={groupsDisabled}
          />
        </DropdownWrap>
      </Block>
      <Block>
        <Label variant='body2' color='grey600' fontWeight={600}>
          Target tags
        </Label>
        <DropdownWrap>
          <WorksiteGroupDropdown
            items={tagItems}
            activeItems={activeTagItems}
            onItemCallback={onActiveTagItemsChange}
            width='100%'
            minWidth='100%'
            disabled={tagsDisabled}
            placeholderText='Select tags'
            selectAllCustomTitle='Select all tags'
          />
        </DropdownWrap>
      </Block>
      {showGroupControls && (
        <OptionsRow flexDirection='row'>
          <Checkbox
            checked={removeNonMatchingMembers}
            onClick={() => onRemoveNonMatchingChange(!removeNonMatchingMembers)}
            label='Remove members who no longer match'
            textVariant='body2'
          />
          <Checkbox
            checked={isActive}
            onClick={() => onActiveChange(!isActive)}
            label='Rule is active'
            textVariant='body2'
          />
        </OptionsRow>
      )}
    </>
  )
}

export default React.memo(EnrollmentTargetBlock)
